import type { InvalidSiteProResponseInterface, SiteProResponseInterface } from '~/server/api/site-pro/get-data.post'
import { fetchRetryParameters, requestHostHeaders } from '~/composables/constants/api'
import type { RequestHostHeadersType } from '~/composables/constants/api'
import type { AdditionalServicesConfig } from '~/server/api/site-pro/get-additional-services-config.post'
import * as Sentry from '@sentry/vue'
import type { SiteProDestinationInterface } from '~/types/destinationTypes'

export const useProContent = () => {
  const fetchProData = async (): Promise<SiteProResponseInterface | InvalidSiteProResponseInterface> => {
    return await $fetch('/api/site-pro/get-data', {
      method: 'POST',
      ...fetchRetryParameters,
      headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
    })
  }

  const fetchAdditionalServicesConfig = async (): Promise<AdditionalServicesConfig | null> => {
    return await $fetch('/api/site-pro/get-additional-services-config', {
      method: 'POST',
      ...fetchRetryParameters,
      headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
    }).catch((error) => {
      Sentry.captureException(error, (scope) => {
        scope.setContext('Server Response', error.data)

        return scope
      })

      return null
    })
  }

  const fetchDestinations = async (): Promise<SiteProDestinationInterface[]> => {
    return await $fetch('/api/site-pro/get-destinations', {
      ...fetchRetryParameters,
      headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
    })
  }

  return {
    fetchProData,
    fetchAdditionalServicesConfig,
    fetchDestinations,
  }
}
